import Vue from "vue";
import {
  Button,
  Select,
  Tabs,
  TabPane,
  Timeline,
  TimelineItem,
  Row,
  Col,
  Menu,
  Submenu,
  MenuItem,
  Aside,
  Container,
  Table,
  TableColumn,
  Tooltip,
  Steps,
  Step,
  Dialog,
  Main,
  Option,
  MenuItemGroup,
  Input,
  Message
} from "element-ui";
Vue.prototype.$message = Message;
Vue.use(Button)
  .use(Select)
  .use(Tabs)
  .use(TabPane)
  .use(Timeline)
  .use(TimelineItem)
  .use(Row)
  .use(Col)
  .use(Menu)
  .use(Submenu)
  .use(MenuItem)
  .use(Aside)
  .use(Container)
  .use(Aside)
  .use(Table)
  .use(TableColumn)
  .use(Tooltip)
  .use(Steps)
  .use(Step)
  .use(Dialog)
  .use(Main)
  .use(Option)
  .use(MenuItemGroup)
  .use(Input)
